// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5671":"514aa522","7527":"514aa522"}[chunkId] + ".chunk.css";
};